import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, Box, StackWrap, Typography, Spacer } from '@telus-uds/components-web';

export const Signature = ({ setSignature, setSignatureValid }) => {
  const { t } = useTranslation();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [firstNameValid, firstNameFeedback] = useMemo(() => {
    if (!firstName) return [undefined, null];
    if (firstName.length >= 2 && firstName.length <= 50) return ['success', null];
    return ['error', t('signature.firstNameValError')];
  }, [firstName]);

  const [lastNameValid, lastNameFeedback] = useMemo(() => {
    if (!lastName) return [undefined, null];
    if (lastName.length >= 2 && lastName.length <= 50) return ['success', null];
    return ['error', t('signature.lastNameValError')];
  }, [lastName]);

  useEffect(() => {
    setSignature({ firstName, lastName });
  }, [firstName, lastName, setSignature]);

  useEffect(() => {
    setSignatureValid(firstNameValid === 'success' && lastNameValid === 'success');
  }, [firstNameValid, lastNameValid, setSignatureValid]);

  return (
    <Box>
      <Typography variant={{ size: 'h4' }} tag="h4">
        {t('signature.message')}
      </Typography>
      <Spacer space={1} />
      <StackWrap direction={'row'} space={5} gap={5}>
        <TextInput
          label={t('signature.firstNameLabel')}
          value={firstName}
          onChange={setFirstName}
          validation={firstNameValid}
          feedback={firstNameFeedback}
        />
        <TextInput
          label={t('signature.lastNameLabel')}
          value={lastName}
          onChange={setLastName}
          validation={lastNameValid}
          feedback={lastNameFeedback}
        />
      </StackWrap>
      <Spacer space={3} />
    </Box>
  );
};
